import callApi from './crmService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/binding`;

export const memberBindingSaByStore = (bindingInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/auto-bind-sp`,
  body: bindingInfo
});

export const checkMemberBind = (info) => callApi({
  method: 'POST',
  endpoint: `${basePath}/check-member-bind`,
  body: info
});
